/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.21.0
 * @since 1.1.0
 */

import { colors } from '../../../../../theme';
import {
    EChartDataKeyEnum,
    IChartAnimateConfiguration,
    IChartColumnWidthConfiguration,
    IChartDataInput,
    IChartGridConfiguration,
    IChartLegendConfiguration,
    IChartPaddingConfiguration,
    IChartScaleConfiguration,
    IChartTooltipConfiguration,
    IChartTooltipWrapperTemplate,
    TChartType,
} from '../../chartTypes';
import { ChartCategoryTooltipWrapperTemplate } from './ChartCategoryTooltip';

export const ChartCategoryType: TChartType = 'intervalStack';
export const ChartCategoryHeight = 430;
export const ChartCategoryPadding: IChartPaddingConfiguration = {
    bottom: 10,
    left: 60,
    right: 0,
    top: 24,
};

export const ChartCategoryAnimate: IChartAnimateConfiguration = {
    enter: {
        animation: 'scaleInY',
        duration: 400,
    },
};

export const ChartCategoryScaleConfiguration: IChartScaleConfiguration = {
    [EChartDataKeyEnum.x]: {
        type: 'cat',
    },
    [EChartDataKeyEnum.y]: {
        min: 0,
    },
};

export const ChartCategoryTooltipConfiguration: IChartTooltipConfiguration = {
    render: (props: IChartTooltipWrapperTemplate) => ChartCategoryTooltipWrapperTemplate(props),
    crosshair: {
        style: {
            fill: colors.borderColorLight,
        },
        type: 'rect',
    },
};

export const ChartCategoryLegendConfiguration: IChartLegendConfiguration = {
    className: 'chart-legend_category',
    dataName: 'chartLegendCategory',
    legendRow: 2,
};

export const ChartCategoryGridConfiguration: IChartGridConfiguration = {
    x: {
        align: 'center',
        lineStyle: {
            lineDash: [],
            lineWidth: 1,
            stroke: colors.borderColorDisabled,
        },
        type: 'line',
    },
    y: {
        lineStyle: {
            lineDash: [],
            lineWidth: 1,
            stroke: colors.borderColorDisabled,
        },
        type: 'line',
    },
};

export const ChartCategoryColumnWidthConfiguration: IChartColumnWidthConfiguration = {
    columnsCount: 4,
    maxWidth: 200,
};

export const ChartCategoryDataConfiguration = (item: IChartDataInput, account: string, total = 0) => {
    const y = item[EChartDataKeyEnum.y][account];
    const reducedY = y / total > .01
        ? y
        : (y > 0 ? total / 100 : 0)
    return ({
        [EChartDataKeyEnum.name]: item[EChartDataKeyEnum.x],
        [EChartDataKeyEnum.x]: account,
        [EChartDataKeyEnum.y]: reducedY,
    });
}
